import { render, staticRenderFns } from "./proof-archive-list.vue?vue&type=template&id=78154bb7&scoped=true&"
import script from "./proof-archive-list.vue?vue&type=script&lang=js&"
export * from "./proof-archive-list.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./proof-archive-list.vue?vue&type=style&index=1&id=78154bb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78154bb7",
  null
  
)

export default component.exports